import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/debounceTime'
import 'rxjs/add/operator/distinctUntilChanged'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/switchMap'
import * as App from '../../app'
import * as FlashMessage from '../../components/flash-message'
import * as IsActive from '../../components/is_active'
import * as Menu from '../../components/menu'
import * as Request from '../../request'
import { ApplicationState } from '../../rootReducer'
import * as Router from '../../router'
import * as Actions from './actions'
import * as Constants from './constants'

export const onCreateUserFail = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: Redux.Store<ApplicationState>,
) => action$.ofType(Request.errorConstant(Constants.ADD_USER))
  .mergeMap((action) => {
    let errorMessage = '';
    if (action.payload.error.response && action.payload.error.response.message) {
      errorMessage = action.payload.error.response.message;
    }
    return ([
      FlashMessage.showFlashError(errorMessage),
    ]);
  })

const initialLoadCommunityUsers = (
    action$: ReduxObservable.ActionsObservable<Redux.Action>,
    store: Redux.Store<ApplicationState>,
    { history }: App.Dependencies,
  ) => action$.ofType(App.SELECT_COMMUNITY, Router.ON_ENTER)
    .filter(() => history.location.pathname.startsWith(Menu.USERS_URL_HOME))
    .map(() => Actions.fetchUsers(store.getState().app.selectedCommunity))

const initialLoadAllUsers = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  { history }: App.Dependencies,
) => action$.ofType(App.SELECT_COMMUNITY, Router.ON_ENTER)
  .filter(() => history.location.pathname.startsWith(Menu.ADMIN_USERS_URL))
  .map(() => Actions.fetchAllUsers())

const onUserUpdate = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: Redux.Store<ApplicationState>,
) => action$.ofType(
    Request.successConstant(Constants.ADD_USER),
    Request.successConstant(Constants.EDIT_USER))
  .map(() => Actions.fetchUsers(store.getState().app.selectedCommunity))

export const epic = ReduxObservable.combineEpics(
  initialLoadCommunityUsers,
  initialLoadAllUsers,
  onCreateUserFail,
  onUserUpdate,
  IsActive.createStatusUpdateEpic(Constants.UPDATE_USER, Actions.updateStatus),
)



// WEBPACK FOOTER //
// ./src/pages/users/epic.ts